import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

/** GET /api/v1/organizations/{organizationId}/brands */
export const fetchOrganizationBrands = createAsyncThunk(
  "organizationBrands/fetch",
  async ({ organizationId } = {}, { rejectWithValue }) => {
    try {
      if (!organizationId) return rejectWithValue("organizationId is required")
      const data = await get(`organizations/${organizationId}/brands`)
      return { data, organizationId }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch organization brands")
    }
  },
  {
    condition: ({ organizationId }, { getState }) => {
      const state = getState().organizationBrands
      return !(
        String(state.organizationId) === String(organizationId) &&
        state.status === "succeeded"
      )
    },
  },
)

const organizationBrandsSlice = createSlice({
  name: "organizationBrands",
  initialState: {
    data: null,
    status: "idle",
    error: null,
    organizationId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationBrands.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchOrganizationBrands.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.data = action.payload?.data ?? null
        state.organizationId = action.payload?.organizationId ?? null
      })
      .addCase(fetchOrganizationBrands.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload ?? "Failed to fetch organization brands"
        state.data = null
      })
  },
})

export default organizationBrandsSlice.reducer
